import React from "react";
import { Base } from "../../components/RootLayout";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <Base>
      <div className="page-config">
        <img src={Assets.page_not_found} alt="page_not_found" />
        <h3>PAGE NOT FOUND</h3>
        <p>We are sorry but the page you are looking for does not exist.</p>
        <Button
          variant="danger"
          className="btn-login"
          style={{ maxWidth: "400px" }}
          onClick={() => navigate(PageRoutes.home)}
        >
          Back
        </Button>
      </div>
    </Base>
  );
};

export default NotFoundPage;
